module.exports = __webpack_public_path__ + "static/IBMPlexSans-Medium-f190ef791843429ff512b6336576c663.woff";